import { RedoShopifyDeliveryMethodType } from "@redotech/redo-model/fulfillments/fulfillment-delivery-method-type";
import {
  RedoBadge,
  RedoBadgeColor,
} from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { memo } from "react";

const deliveryMethodBadgeColor: Record<
  RedoShopifyDeliveryMethodType,
  RedoBadgeColor
> = {
  [RedoShopifyDeliveryMethodType.Local]: "blue",
  [RedoShopifyDeliveryMethodType.None]: "gray",
  [RedoShopifyDeliveryMethodType.PickupPoint]: "blue",
  [RedoShopifyDeliveryMethodType.PickUp]: "blue",
  [RedoShopifyDeliveryMethodType.Retail]: "gray",
  [RedoShopifyDeliveryMethodType.Shipping]: "success",
};

export const deliveryMethodText = {
  [RedoShopifyDeliveryMethodType.Local]: "Local delivery",
  [RedoShopifyDeliveryMethodType.None]: "None",
  [RedoShopifyDeliveryMethodType.PickupPoint]: "Pickup point",
  [RedoShopifyDeliveryMethodType.PickUp]: "Pick up",
  [RedoShopifyDeliveryMethodType.Retail]: "Retail",
  [RedoShopifyDeliveryMethodType.Shipping]: "Shipping",
};

export const DeliveryMethodBadge = memo(function DeliveryMethodBadge({
  deliveryMethod,
}: {
  deliveryMethod: RedoShopifyDeliveryMethodType;
}) {
  return (
    <RedoBadge
      color={deliveryMethodBadgeColor[deliveryMethod]}
      size="xs"
      text={deliveryMethodText[deliveryMethod]}
    />
  );
});
